import React, { useEffect, useState } from 'react';
import { Card, Typography, Spin, message } from 'antd';
import StandardTable from '../../../components/common/StandardTable';
import { fetchSqlData } from '../../../services/api';

const { Title } = Typography;

interface ToP6TableDetailsProps {
  tableName: string;
  onBack: () => void;
}

const ToPlnP6TableDetails: React.FC<ToP6TableDetailsProps> = ({ tableName, onBack }) => {
  const [columns, setColumns] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!tableName) return;
    const fetchColumnsAndData = async () => {
      setLoading(true);
      try {
        const colQuery = `SELECT COLUMN_NAME FROM INFORMATION_SCHEMA.COLUMNS WHERE TABLE_SCHEMA = 'dbo' AND TABLE_NAME = '${tableName}' ORDER BY ORDINAL_POSITION;`;
        const colResult = await fetchSqlData('INFORMATION_SCHEMA.COLUMNS', 'TABLE_NAME', tableName, 'PPMTRAIN');
        let columnNames: string[] = [];
        if (Array.isArray(colResult)) {
          if (colResult[0] && colResult[0].COLUMN_NAME) {
            columnNames = colResult.map((row: any) => row.COLUMN_NAME);
          } else if (colResult[0] && colResult[0].column_name) {
            columnNames = colResult.map((row: any) => row.column_name);
          }
        }
        if (columnNames.length === 0) throw new Error('No columns found');

        // Some backends/views can return duplicate column rows; ensure unique columns to prevent UI duplication.
        const seen = new Set<string>();
        const uniqueColumnNames = columnNames.filter((c) => {
          if (seen.has(c)) return false;
          seen.add(c);
          return true;
        });

        const tableColumns = uniqueColumnNames.map((col) => ({
          title: col,
          dataIndex: col,
          key: col,
          ellipsis: false,
          width: 150,
          render: (text: any) => String(text ?? '') || '-',
          exportValue: (row: any) => (row && row[col] != null ? String(row[col]) : ''),
        }));
        setColumns(tableColumns);

        const tableData = await fetchSqlData(tableName, undefined, undefined, 'PPMTRAIN');
        let formattedData: any[] = [];
        if (Array.isArray(tableData)) {
          formattedData = tableData.map((row, idx) => ({ key: idx, ...row }));
        }
        setData(formattedData);
      } catch (err: any) {
        message.error('Failed to fetch table details!');
      } finally {
        setLoading(false);
      }
    };
    fetchColumnsAndData();
  }, [tableName]);

  return (
    <Card>
      <Title level={4}>
        <a onClick={onBack} style={{ marginRight: 16, fontSize: 18 }}>&larr; Back</a>
        Table Details: {tableName}
      </Title>
      {loading ? (
        <Spin />
      ) : (
        <StandardTable
          dataSource={data}
          columns={columns}
          rowKey="key"
          bordered
          scroll={{ x: columns.reduce((sum, col) => sum + (col.width || 150), 0) }}
        />
      )}
    </Card>
  );
};

export default ToPlnP6TableDetails;
